import axios from 'axios'
const { get, post } = axios

const getToken = () => document.querySelector('[name="csrf-token"]').content

const buildHeaders = () => ({
  headers: {
    'Content-Type': 'application/json',
    'X-CSRF-Token': getToken(),
  },
})

export const builderFetch = url => get(url, buildHeaders())

export const stagePlgForm = formData =>
  post('/product/builder-demo/stage_form', formData, buildHeaders())

export const stagePlgPdf = file => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ event: 'plg_form_uploaded' })

  const body = new FormData()
  body.append('file', file)
  return post('/product/builder-demo/upload_pdf', body, {
    headers: { 'X-CSRF-Token': getToken() },
  })
}

export const fetchForm = form_id =>
  builderFetch(`/api/v3/forms/${form_id}?format=flat`)

export const fetchStudioPdf = form_id =>
  builderFetch(`/easy_form_pdf.json?form_id=${form_id}`)

export const fetchEntryTypes = () =>
  builderFetch(`/entry_types/studio_types.json`)

export const fetchOperationTypes = () => builderFetch('/operation_types.json')

export const fetchReferenceImages = () =>
  builderFetch('/reference_images.json')

export const fetchReferenceData = appId =>
  !appId// includes appId === 0
    ? builderFetch(`/api/v3/reference_data`)
    : builderFetch(`/api/v3/reference_data?form_id=${appId}`)
